import React from 'react'
import { ReactComponent as GirlIcon } from 'assets/svg/login/main_girl.svg'
import { ReactComponent as KavkomLogo } from 'assets/svg/login/main_logo.svg'
import { WhitelabelConfig } from 'hooks'

let Logo = KavkomLogo

if (WhitelabelConfig?.logo?.full) {
    const { url, width, height } = WhitelabelConfig.logo.full
    Logo = () => <img src={url} width={width} height={height} alt="Company logo" />
}

export const Logotypes = () => (
    <div className="login__logotypes mb-3">
        <Logo />
        <GirlIcon className="login__logotypes--girl" />
    </div>
)
